<style scoped>
  .label{
    position: relative;
    float: left;
    display: inline-block;
    vertical-align: top;
    width: 120px;
    padding-right: 6px;
    text-align: right;
    color: #888;
  }
  .label:before{
    content: ':';
    position: absolute;
    top: 0;
    right: 0;
  }
  .value{
    padding-left: 125px;
    white-space: normal;
  }
  .user-flow{
    margin-top: 20px;
  }
  .user-flow .value{
    padding-top: 3px;
    padding-left: 130px;
  }
  .line /deep/ .ivu-table-expanded-cell{
    padding: 20px 4px;
  }
</style>
<template>
  <div style="margin-top:20px">
    <ReceiptBillCard 
      v-if="get_value&&receipt_type==='receipt_bills'"
      v-model="model"
      :show-action="false"
    />
    <ReceivableBillCard 
      v-if="get_value&&receipt_type==='receivable_bills'"
      v-model="model"
      :show-action="false"
    />
    <ReceiptAccrualBillCard 
      v-if="get_value&&receipt_type==='receipt_accrual_bills'"
      v-model="model"
      :show-action="false"
    /> 
  </div>
</template>
<script>
  import ReceiptBillCard from '@/views/fin_bill/components/receipt_bill_card'
  import ReceivableBillCard from '@/views/fin_bill/components/receivable_bill_card'
  import ReceiptAccrualBillCard from '@/views/fin_bill/components/receipt_accrual_bill_card'
  import Util from '@/libs/util';
  const { fin_receipt_bill_detail, fin_receivable_bill_detail, fin_receipt_accrual_bill_detail } = Util.api
  // fin_receipt_bill_detail fin_receivable_bill_detail fin_receipt_accrual_bill_detail
  const url_hash = {
    receipt_bills: fin_receipt_bill_detail,
    receivable_bills: fin_receivable_bill_detail,
    receipt_accrual_bills: fin_receipt_accrual_bill_detail
  }
  export default {
    components: { ReceiptBillCard, ReceivableBillCard, ReceiptAccrualBillCard },
    props: {
      model_id: {
        type: Number
      },
      receipt_type: {
        type: String
      }
    },
    data() {
      return {
        getValue: false,
        model: {},
      }
    },
    computed: {
      get_value() {
        return !!Object.values(this.model).length
      },
      getDetailUrl() {
        return url_hash[this.receipt_type]
      }
    },
    created() {
     
    },
    mounted() {
      Util.http.get(this.getDetailUrl, { id: this.model_id }).then(data => {
        this.model = (data && data.bill) || {}
      })
    },
    methods: {

    }
  }
</script>
